/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCollectionContainer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 21h-4v-2h4zm-6 0h-4v-2h4zm-6 0H6v-2h4zm-6 0H2v-2h2zm18-4h-4v-2h4zm-6 0h-4v-2h4zm-6 0H6v-2h4zm-6 0H2v-2h2zm18-4H2V3h20zM4 11h16V5H4zm14-2h-2V7h2zm-6 0H6V7h6z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCollectionContainer as CollectionContainer };
